import { forwardRef } from "react";
import { NoteListItem } from "creso-core/types";
import { cn } from "web-design-system";

export const NoteListItemComponent = forwardRef<
  HTMLButtonElement,
  {
    note: NoteListItem;
    onSelect: (note: NoteListItem) => void;
    isSelected: boolean;
    isNextSelected: boolean;
  }
>(function NoteListItemComponent(
  { note, onSelect, isSelected, isNextSelected },
  ref
) {
  return (
    <button
      ref={ref}
      key={note.id}
      type="button"
      onClick={() => onSelect(note)}
      className={cn(
        "w-full text-left p-4 h-22 transition-colors border border-transparent border-b-border hover:bg-secondary/40",
        !isSelected && "last-of-type:border-transparent",
        isSelected &&
          "rounded-lg bg-background border border-border hover:bg-background",
        isNextSelected && "border-transparent"
      )}
    >
      <p
        className={cn(
          "text-sm  line-clamp-2",
          isSelected ? "font-semibold" : ""
        )}
      >
        {note.title}
      </p>
      <p className="text-xs text-muted-foreground mt-2">
        For: {note.client_name ?? "Self"}
      </p>
    </button>
  );
});
